import React from "react";

export const Mail: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg {...props} width="112" height="75" viewBox="0 0 112 75" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M101 9.375C101 4.21875 96.95 0 92 0H20C15.05 0 11 4.21875 11 9.375V65.625C11 70.7812 15.05 75 20 75H92C96.95 75 101 70.7812 101 65.625V9.375ZM92 9.375L56 32.8125L20 9.375H92ZM92 65.625H20V18.75L56 42.1875L92 18.75V65.625Z" fill="currentColor"/>
</svg>
);
